module.exports = __webpack_public_path__ + "KaTeX_SansSerif-Italic.17682cd7.woff";